/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UboDeclarationResponseLegalRepresentative
 */
export interface UboDeclarationResponseLegalRepresentative {
    /**
     * 
     * @type {string}
     * @memberof UboDeclarationResponseLegalRepresentative
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof UboDeclarationResponseLegalRepresentative
     */
    lastName: string;
}

/**
 * Check if a given object implements the UboDeclarationResponseLegalRepresentative interface.
 */
export function instanceOfUboDeclarationResponseLegalRepresentative(value: object): value is UboDeclarationResponseLegalRepresentative {
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    return true;
}

export function UboDeclarationResponseLegalRepresentativeFromJSON(json: any): UboDeclarationResponseLegalRepresentative {
    return UboDeclarationResponseLegalRepresentativeFromJSONTyped(json, false);
}

export function UboDeclarationResponseLegalRepresentativeFromJSONTyped(json: any, ignoreDiscriminator: boolean): UboDeclarationResponseLegalRepresentative {
    if (json == null) {
        return json;
    }
    return {
        
        'firstName': json['firstName'],
        'lastName': json['lastName'],
    };
}

export function UboDeclarationResponseLegalRepresentativeToJSON(value?: UboDeclarationResponseLegalRepresentative | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'firstName': value['firstName'],
        'lastName': value['lastName'],
    };
}

